import React from 'react';
import Pagination from '../../../components/base/Pagination/Pagination';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import { addPaymentLogColumns, paymentLogColumns } from '../constants';
import { MoreFormatter } from '../../../utils/formatters';

export default function PaymentLogGrid(props) {
  const {
    data = [],
    loadData = () => {},
    onClickByRow = () => {},
    meta = {},
    name = 'plp-list',
    columns = paymentLogColumns,
    hidePagination = false,
  } = props;

  return (
    <div className="plp-table g-0">
      <div className="frame">
        <div className="sticky-table-wrapper custom-scroll-theme">
          <CustomizedGrid className="plp-grid" data={data} columns={columns} additionalColumns={addPaymentLogColumns} name={name} settingsFormatter={MoreFormatter} onClickByRow={onClickByRow} />
        </div>
      </div>
      {!hidePagination ? <Pagination meta={meta} list={data} handleChangeMeta={loadData} /> : null}
    </div>
  );
}
